import axios from "axios";
import { trim } from "lodash";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from 'react-select';
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";


import moment from "moment/moment";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";

const options = [
  { value: 'nsf', label: 'NSF' },
  { value: 'penalties', label: 'Penalties' },
  { value: 'hydro_inv', label: 'Hydro Inv' },

]



function RentDetailsManagerPr({ allowedRoles }) {
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();

  useAuthentication(allowedRoles)

  const { designation, Logout } = useAuth()
  const { id } = useParams();
  const _ = require("lodash");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [otherExpenses, setotherExpenses] = useState([]);
  const [readOnlyFields, setReadOnlyFields] = useState([])
  const [userDetails, setUserDetails] = useState("")

  const [tenantDataEdit, settenantDataEdit] = useState({})



  const [tenantData, settenantData] = useState({


    apartment: "",
    remarks: "",
    cheque_no: "",
    expenses_by_tenant: "",
    penalties: "",
    penalty: "",
    bank_name: "",
    bank_account_number: "",
    building_id: "",
    buliding_name: "",
    city: "",
    country: "",
    country_name: "",
    email: "",
    first_name: "",
    internet: "",

    last_name: "",
    lease_end_date: "",
    lease_start_date: "",
    locker: "",
    middle_name: "",
    monthly_rent: "",
    parking: "",
    Payment_mode: "",
    phone_number: "",
    postal_code: "",
    province: "",
    status: false,
    street_address: "",
    taxes: "",
    tenant_code: "",
    tenant_image: "",
    unit_id: 1,
    unit_type: "",
    payment_date: "",
    total_amount: "",
    balance: "",
    qst: "",
    gst: "",
    adjust_advance_rent: 0,


    user_name: "",
    tenant_name: "",

    hydro_inv: "",
    collected_amount: "",
    nsf: "",
    chq_date_clearence: "",
    chq_date_collectted: "",
    chq_date_received: "",
    cash_collected_by: "",
    cash_collected_date: "",

  });



  const {
    payment_date,
    remarks,
    penalty,
    cheque_no,
    expenses_by_tenant,
    penalties,
    hydro_inv,

    tenant_name,
    bank_account_number,
    bank_name,

    apartment,
    building_id,
    buliding_name,
    city,
    country,
    country_name,
    email,
    first_name,
    total_amount,
    internet,
    adjust_advance_rent,
    last_name,
    lease_end_date,
    lease_start_date,
    locker,
    middle_name,
    monthly_rent,
    parking,
    Payment_mode,
    phone_number,
    postal_code,
    province,
    status,
    street_address,
    taxes,
    gst, qst,
    tenant_code,
    tenant_image,
    unit_id,
    unit_type,
    nsf,

    collected_amount,
    balance,
    chq_date_received,
    chq_date_collectted,
    chq_date_clearence,
    user_name,
    cash_collected_by,
    cash_collected_date,
  } = tenantData;



  const handleEditField = () => {
    setReadOnlyFields([])
  }



  const [total__amount_cal, settotal__amount_cal] = useState(0);
  const [advancedRentCol, setadvancedRentCol] = useState(0);
  const navigate = useNavigate()



  const validation = () => {

    const errors = {};


    if (!Payment_mode || !trim(Payment_mode)) {
      errors.Payment_mode = "Please Choose a payment method.";
    }

    if (monthly_rent) {

      if (!Number.isInteger(Number(monthly_rent))) {
        errors.monthly_rent = "Please Enter a numerice value.";
      }
    }
    if (parking) {
      if (!Number.isInteger(Number(parking))) {
        errors.parking = "Please Enter a numerice value.";
      }
    }
    // if (taxes) {
    //   if (!Number.isInteger(Number(taxes))) {
    //     errors.taxes = "Please Enter a numerice value.";
    //   }
    // }
    if (qst) {
      if (!Number.isInteger(Number(qst))) {
        errors.qst = "Please Enter a numerice value.";
      }
    }
    if (gst) {
      if (!Number.isInteger(Number(gst))) {
        errors.gst = "Please Enter a numerice value.";
      }
    }
    if (internet) {
      if (!Number.isInteger(Number(internet))) {
        errors.internet = "Please Enter a numerice value.";
      }
    }
    if (locker) {
      if (!Number.isInteger(Number(locker))) {
        errors.locker = "Please Enter a numerice value.";
      }
    }
    if (nsf) {
      if (!Number.isInteger(Number(nsf))) {
        errors.nsf = "Please Enter a numerice value.";
      }
    }
    // if (advance_rent) {
    //   if (!Number.isInteger(Number(advance_rent))) {
    //     errors.advance_rent = "Please Enter a numerice value.";
    //   }
    // }
    // if (laundry_card_deposit) {
    //   if (!Number.isInteger(Number(laundry_card_deposit))) {
    //     errors.laundry_card_deposit = "Please Enter a numerice value.";
    //   }
    // }
    // if (key_deposit) {
    //   if (!Number.isInteger(Number(key_deposit))) {
    //     errors.key_deposit = "Please Enter a numerice value.";
    //   }
    // }
    if (hydro_inv) {
      if (!Number.isInteger(Number(hydro_inv))) {
        errors.hydro_inv = "Please Enter a numerice value.";
      }
    }
    if (penalties) {
      if (!Number.isInteger(Number(penalties))) {
        errors.penalties = "Please Enter a numerice value.";
      }
    }
    if (expenses_by_tenant) {
      if (!Number.isInteger(Number(expenses_by_tenant))) {
        errors.expenses_by_tenant = "Please Enter a numerice value.";
      }
    }

    if (advancedRentCol < adjust_advance_rent) {
      errors.adjust_advance_rent = "You don't have enough Advance amount";
    }




    return errors;
  };

  const handleData = (e) => {

    if (e.target.name == "status_adj") {
      settenantData({ ...tenantData, [e.target.name]: e.target.checked });
    } else {
      settenantData({ ...tenantData, [e.target.name]: e.target.value });
    }
  };

  const formSubmit = (e) => {
    e.preventDefault();

    setErrorMessage({})

    const Valid = validation();
    setErrorMessage(Valid);

    if (Valid && Object.keys(Valid)?.length == 0) {
      setLoading(true)

      let sendTenantData = {}

      if (Payment_mode == "Chq" || Payment_mode == "pad") {
        sendTenantData = {
          ...tenantData,
          id, outstanding_previous_month: balance, totalAmount: total__amount_cal
        }
      }
      else if (Payment_mode == "Cash") {
        sendTenantData = {
          ...tenantData,
          id, outstanding_previous_month: balance, totalAmount: total__amount_cal, cash_collected_by: tenantData?.status == "Pending" ? tenantData?.cash_collected_by : userDetails
        }
      }

      else {
        sendTenantData = {
          ...tenantData,
          id, outstanding_previous_month: balance, totalAmount: total__amount_cal, payment_date: new Date().toJSON().slice(0, 10)
        }
      }



      axios.post("/accountant/Collection/rent/create", sendTenantData).then(res => {
        if (res.status == 200) {
          setLoading(false)

          navigate(`/manager/collection-management/${building_id
            }`)
        }
      }).catch(error => {
        setLoading(false)

      })

    }



  };

  useEffect(() => {
    axiosFetch({
      axiosInstance: axios,
      method: 'GET',
      url:`/accountant/Collection/tenant/details/${id}`,


  }).then((res) => {
      settenantData(res?.data);

      settenantDataEdit(res?.data)
      setadvancedRentCol(res?.data.advance_rent)

    });



  }, [id]);

  useEffect(() => {
    let readOnlyData = []

    if (tenantData.internet !== undefined && tenantData.internet !== null && Number(tenantData.internet) >= 0) {

      readOnlyData.push("internet")
    }
    if (tenantData.parking !== undefined && tenantData.parking !== null && Number(tenantData.parking) >= 0) {
      readOnlyData.push("parking")
    }
    if (tenantData.monthly_rent !== undefined && tenantData.monthly_rent !== null && Number(tenantData.monthly_rent) >= 0) {
      readOnlyData.push("monthly_rent")
    }

    if (tenantData.qst !== undefined && tenantData.qst !== null && Number(tenantData.qst) >= 0) {

      readOnlyData.push("qst")
    }
    if (tenantData.gst !== undefined && tenantData.gst !== null && Number(tenantData.gst) >= 0) {
      readOnlyData.push("gst")
    }
    if (tenantData.locker !== undefined && tenantData.locker !== null && Number(tenantData.locker) >= 0) {
      readOnlyData.push("locker")
    }

    if (tenantData.nsf !== undefined && tenantData.nsf !== null && Number(tenantData.nsf) >= 0) {
      readOnlyData.push("nsf")
    }

    if (tenantData.hydro_inv !== undefined && tenantData.hydro_inv !== null && Number(tenantData.hydro_inv) >= 0) {
      readOnlyData.push("hydro_inv")
    }
    if (tenantData.balance !== undefined && tenantData.balance !== null && Number(tenantData.balance) >= 0) {
      readOnlyData.push("balance")
    }
    if (tenantData.penalties !== undefined && tenantData.penalties !== null && Number(tenantData.penalties) >= 0) {
      readOnlyData.push("penalties")
    }
    // if (tenantData.collected_amount !== undefined && tenantData.collected_amount !== null  && Number(tenantData.collected_amount) >= 0) {

    //   readOnlyData.push("collected_amount")
    // }

    setReadOnlyFields(readOnlyData)

  }, [tenantDataEdit])

  useEffect(() => {
    const arr = []
    if (readOnlyFields.includes("nsf")) {
      arr.push({ value: 'nsf', label: 'NSF' })
    }
    if (readOnlyFields.includes("penalties")) {
      arr.push({ value: 'penalties', label: 'Penalties' })
    }
    if (readOnlyFields.includes("hydro_inv")) {
      arr.push({ value: 'hydro_inv', label: 'Hydro Inv' })
    }
    setotherExpenses(arr)
  }, [readOnlyFields])


  useEffect(() => {
    let totalAmountset = 0;


    if (Number.isInteger(Number(monthly_rent))) {
      totalAmountset = totalAmountset + Number(monthly_rent);
    }
    if (Number.isInteger(Number(parking))) {
      totalAmountset = totalAmountset + Number(parking);
    }
    // if (Number.isInteger(Number(taxes))) {
    //   totalAmountset = totalAmountset + Number(taxes);
    // }
    if (Number.isInteger(Number(gst))) {
      totalAmountset = totalAmountset + Number(gst);
    }
    if (Number.isInteger(Number(qst))) {
      totalAmountset = totalAmountset + Number(qst);
    }
    if (Number.isInteger(Number(locker))) {
      totalAmountset = totalAmountset + Number(locker);
    }
    if (Number.isInteger(Number(internet))) {
      totalAmountset = totalAmountset + Number(internet);
    }
    if (Number.isInteger(Number(nsf))) {
      totalAmountset = totalAmountset + Number(nsf);
    }
    // if (Number.isInteger(Number(advance_rent))) {
    //   totalAmountset = totalAmountset - Number(advance_rent);
    // }
    // if (Number.isInteger(Number(laundry_card_deposit))) {
    //   totalAmountset = totalAmountset + Number(laundry_card_deposit);
    // }
    // if (Number.isInteger(Number(key_deposit))) {
    //   totalAmountset = totalAmountset + Number(key_deposit);
    // }
    if (Number.isInteger(Number(hydro_inv))) {
      totalAmountset = totalAmountset + Number(hydro_inv);
    }
    if (Number.isInteger(Number(penalties))) {
      totalAmountset = totalAmountset + Number(penalties);
    }
    if (Number.isInteger(Number(expenses_by_tenant))) {
      totalAmountset = totalAmountset - Number(expenses_by_tenant);
    }
    if (Number.isInteger(Number(adjust_advance_rent))) {


      if (advancedRentCol > adjust_advance_rent) {

        totalAmountset = totalAmountset - Number(adjust_advance_rent);
      }
    }

    settotal__amount_cal(totalAmountset);


  }, [tenantData]);

  useEffect(() => {
    axiosFetch({
      axiosInstance: axios,
      method: 'GET',
      url: `/userDetails`,
    }).then(res => {
      const acoounatantName = `${res.data?.UserDetails?.first_name} ${res.data?.UserDetails?.middle_name
        }  ${res.data?.UserDetails?.last_name} `

      setUserDetails(acoounatantName)
    }).catch((e) => {

      Logout()
    })
  }, [])
  useEffect(() => {


    let errors = {}

    if (advancedRentCol < adjust_advance_rent) {
      errors.adjust_advance_rent = "You don't have enough Advance amount";
    }
    else {
      if (Number.isInteger(Number(adjust_advance_rent))) {
        const valueAdv = advancedRentCol - Number(adjust_advance_rent)
        settenantData({ ...tenantData, advance_rent: valueAdv });
      }

    }





    setErrorMessage(errors)

  }, [adjust_advance_rent])
  return (
    <>
      <DashboardLayouts>
        {loading && <Loader />}
        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link

              to={designation == "Owner" ? `/owner/collection-management/${building_id
                }` : `/accountant/collection-management/${building_id
                }`}

              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Back to Unit List</h3>
            </Link>
          </div>
        </div>

        <div className="col-md order-1 order-xl-2">
          <ul className="">
            <li className=" list-info">
              <span>Tenant Name:</span>
              <p>{tenant_name}</p>
            </li>

            <li className=" list-info">
              <span>Unit Name :</span>
              <p>
                {tenantData?.unit_name}
              </p>
            </li>



          </ul>
        </div>

        <form
          onSubmit={formSubmit}
          className="dash-form add-form add-building-area"
        >
          <div className="row">
            <div className="col">
              <div className="row gy-1 gy-md-4 ">



                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Outstanding Amount

                    </label>
                    <input
                      type="text"
                      value="0"
                      readOnly={readOnlyFields?.includes("balance")}
                      name="balance"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Outstanding Previous Month"
                    />
                    {/* {errorMessage?.outstanding_previous_month ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.outstanding_previous_month}
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>

                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Monthly Rent
                    </label>
                    <input
                      type="text"

                      readOnly={readOnlyFields?.includes("monthly_rent")}
                      value={monthly_rent ? monthly_rent : tenantData?.monthly_rent}
                      name="monthly_rent"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder=" Monthly Rent"
                    />
                    {errorMessage?.monthly_rent ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.monthly_rent}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Gst (%)<span className="must-field">*</span>
                    </label>
                    <input
                      type="text"
                      value={gst}
                      readOnly={readOnlyFields?.includes("gst")}

                      name="gst"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Gst "
                    />
                    {errorMessage?.gst ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.gst}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Qst (%)<span className="must-field">*</span>
                    </label>
                    <input
                      type="text"
                      value={qst}
                      readOnly={readOnlyFields?.includes("qst")}


                      name="qst"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Qst"
                    />
                    {errorMessage?.qst ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.qst}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>




                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Parking
                    </label>
                    <input
                      type="text"

                      readOnly={readOnlyFields?.includes("parking")}
                      value={parking ? parking : tenantData?.parking}
                      name="parking"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder=" Parking"
                    />
                    {errorMessage?.parking ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.parking}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Internet
                    </label>
                    <input
                      type="text"

                      readOnly={readOnlyFields?.includes("internet")}

                      value={internet ? internet : tenantData?.internet}
                      name="internet"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Internet"
                    />
                    {errorMessage?.internet ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.internet}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Locker
                    </label>
                    <input
                      type="text"

                      readOnly={readOnlyFields?.includes("locker")}

                      value={locker ? locker : tenantData?.locker}
                      name="locker"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Locker"
                    />
                    {errorMessage?.locker ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.locker}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>



                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group position-relative">
                    <label htmlFor="" className="form-lbl">
                      Expenses by Tenant
                    </label>
                    <input
                      type="text"
                      value={expenses_by_tenant}
                      name="expenses_by_tenant"
                      // readOnly={readOnlyFields?.includes("hydro_inv")}

                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Expenses by tenant"
                    />

                    {errorMessage?.expenses_by_tenant ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.expenses_by_tenant}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-xl-4 col-md-6 mb-2 ">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Other Expenses
                    </label>



                    <Select
                      value={otherExpenses}
                      isMulti
                      name="colors"
                      options={options}
                      onChange={(item) => setotherExpenses(item)}
                      // className="py-3"

                      classNamePrefix="select Expenses"
                    />



                  </div>
                </div>



                {
                  otherExpenses?.map(oei =>
                    <>


                      <div className="col-xl-4 col-md-6 mb-2">
                        <div className="form-group position-relative">
                          <label htmlFor="" className="form-lbl">
                            {oei.label}
                          </label>
                          <input
                            type="text"
                            value={tenantData?.[oei.value]}
                            name={oei.value}
                            readOnly={readOnlyFields?.includes(oei.value)}

                            onChange={(e) => handleData(e)}
                            className={`form-control form-g1`}
                            placeholder={oei.value}
                          />
                          {oei.value == "hydro_inv" && <Link target='_blank'
                            to={designation == "Owner" ? `/owner/edit-tenant/${id}` : `/accountant/edit-tenant/${id}`}

                          >
                            <FaEye className="position-absolute top-50 mt-2 me-3 end-0" />
                          </Link>}
                          {errorMessage?.[oei.value] ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.[oei.value]}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>

                  )
                }



                {/* {!otherExpenses?.includes("hydro_inv") ?  <>
                
                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">

                  </div>
                </div>

                </>  :
                
               <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group position-relative">
                    <label htmlFor="" className="form-lbl">
                      Hydro Inv
                    </label>
                    <input
                      type="text"
                      value={hydro_inv}
                      name="hydro_inv"
    readOnly={readOnlyFields?.includes("hydro_inv")}

                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Hydro Inv"
                    />
               <Link to='/accountant/hydro-inv'>     <FaEye className="position-absolute top-50 mt-2 me-3 end-0" /></Link>
                    {errorMessage?.hydro_inv ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.hydro_inv}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div> 
          
                
                }
                {!otherExpenses?.includes("nsf") ?  <>
                
                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">

                  </div>
                </div>

                </>  :
                
                   <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      NSF
                    </label>
                    <input
                      type="text"
                      value={nsf}
                      name="nsf"
    readOnly={readOnlyFields?.includes("nsf")}

                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="NSF"
                    />
                    {errorMessage?.nsf ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.nsf}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  </div>
          
                
                }
                {!otherExpenses?.includes("penalty") ?  <>
                
                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">

                  </div>
                </div>

                </>  :
                
                   <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Penalty
                    </label>
                    <input
                      type="text"
                      value={penalty}
                      name="penalty"
    readOnly={readOnlyFields?.includes("penalty")}

                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Penalty"
                    />
                    {errorMessage?.penalty ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.penalty}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  </div>
          
                
                }
                */}

                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Collected Amount
                    </label>
                    <input
                      type="text"
                      value={tenantData?.status == "Pending" ? tenantData?.Collected_Amount : collected_amount}
                      name="collected_amount"
                      readOnly={tenantData?.status == "Pending"}

                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Collected amount"
                    />
                    {errorMessage?.collected_amount ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.collected_amount}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 mb-2 relative">

                  <div className="form-group">
                    <div className="d-flex justify-content-between">
                      <label htmlFor="" className="form-lbl">
                        Advance
                      </label>
                    </div>
                    <input
                      type="text"
                      value={tenantData?.advance_rent}
                      name="advance_rent"
                      readOnly='true'

                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="advance_rent"
                    />
                    {/* / */}
                  </div>
                </div>
                <div className="col-xl-9  mb-2 relative">
                  <div className="d-flex gap-4">
                    <p> Are you want to pay with Advance Rent ?</p>
                    <label className="switch">
                      <input
                        onChange={(e) => handleData(e)}
                        type="checkbox"
                        className="switch-input"
                        // checked={statusShow ? true : status}
                        // value={status}
                        name="status_adj"
                      />
                      <span
                        className="switch-label"
                        data-on="Active"
                        data-off="Inactive"
                      ></span>
                      <span className="switch-handle"></span>
                    </label>
                  </div>
                </div>

                {tenantData?.status_adj &&
                  <div className="col-xl-4 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Adjust Advance Rent
                      </label>
                      <input
                        type="text"
                        value={adjust_advance_rent}
                        name="adjust_advance_rent"


                        onChange={(e) => handleData(e)}
                        className={`form-control form-g1`}
                        placeholder="Adjust advance rent"
                      />
                      {errorMessage?.adjust_advance_rent ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.adjust_advance_rent}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                }

                <div className="col-xl-4 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Total
                    </label>
                    <input
                      type="text"
                      value={total__amount_cal}
                      name="total"
                      readOnly
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Total"
                    />
                    {errorMessage?.total ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.total}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 mb-2 ">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Payment Mode
                      <span className="must-field">*</span>
                    </label>
                    <select
                      type="text"
                      value={Payment_mode}
                      name="Payment_mode"
                      id="Payment_mode"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                    >
                      <option value="">Choose Payment</option>
                      <option value="Cash">Cash</option>
                      <option value="Chq">Cheque</option>

                      <option value="etransfer">E-Transfer</option>
                      <option value="intrac">Intrac</option>
                      <option value="pad">PAD</option>
                    </select>

                    {errorMessage?.Payment_mode ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.Payment_mode}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>


                {(Payment_mode == "Chq" || Payment_mode == "pad") ?
                  <>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Record Date
                        </label>
                        <input
                          type="date"
                          value={chq_date_collectted}
                          name="chq_date_collectted"

                          onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                        />
                        {errorMessage?.payment_date ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.payment_date}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>



                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Bank name
                        </label>


                        <div className="form-group">

                          <select
                            value={bank_name}
                            name="bank_name"
                            onChange={(e) => handleData(e)}
                            className={`form-control form-g1`}
                            placeholder={`Enter Bank Name`}
                          >
                            <option value="">Choose Bank</option>

                            <option >
                              State Bank Of India
                            </option>
                            <option >
                              ICICI Bank
                            </option>
                            <option >
                              Bank of Boroda
                            </option>


                          </select>

                          {errorMessage?.bank_name ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.bank_name}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Bank Account Number
                        </label>
                        <input
                          type="text"

                          readOnly={readOnlyFields?.includes("bank_account_number")}
                          value={bank_account_number ? bank_account_number : tenantData?.bank_account_number}
                          name="bank_account_number"
                          onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                          placeholder="Bank Account Number"
                        />
                        {errorMessage?.bank_account_number ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.bank_account_number}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Date of Cheque received
                        </label>
                        <input
                          type="date"
                          value={chq_date_received}
                          name="chq_date_received"

                          onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                        />
                        {errorMessage?.chq_date_received ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.chq_date_received}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Cheque Number
                        </label>
                        <input
                          type="text"

                          readOnly={readOnlyFields?.includes("bank_account_number")}
                          value={cheque_no}
                          name="cheque_no"
                          onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                          placeholder=" Cheque Number"
                        />
                        {errorMessage?.bank_account_number ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.bank_account_number}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Cheque Clearence Date
                        </label>
                        <input
                          type="date"
                          value={chq_date_clearence}
                          name="chq_date_clearence"

                          onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                        />
                        {errorMessage?.payment_date ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.payment_date}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>






                  </>

                  : <>

                    <div className="col-xl-4 col-md-6 mb-2 ">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Record Date
                        </label>
                        <input
                          type="text"
                          value={new Date().toJSON().slice(0, 10)}
                          name="payment_date"
                          readOnly
                          // onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                        />
                        {errorMessage?.payment_date ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.payment_date}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>

                }

                {
                  (Payment_mode == "Cash") ?

                    <>
                      <div className="col-xl-4 col-md-6 mb-2">
                        <div className="form-group position-relative">
                          <label htmlFor="" className="form-lbl">
                            Collected by
                          </label>
                          <input
                            type="text"
                            value={tenantData?.status == "Pending" ? tenantData?.cash_collected_by : userDetails}
                            name="cash_collected_by"


                            // readOnly={readOnlyFields?.includes("hydro_inv")}
                            readOnly
                            // onChange={(e) => handleData(e)}
                            className={`form-control form-g1`}
                            placeholder=" Collected BY"
                          />


                        </div>
                      </div>
                      <div className="col-xl-4 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Collected Date
                          </label>
                          <input
                            type={tenantData?.status == "Pending" ? "text" : "date"}
                            value={tenantData?.status == "Pending" ? moment(tenantData?.cash_collected_date).format("MMM Do YY") : cash_collected_date}
                            name="cash_collected_date"
                            readOnly={tenantData?.status == "Pending"}
                            onChange={(e) => handleData(e)}
                            className={`form-control form-g1`}
                          />
                          {errorMessage?.cash_collected_date ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.cash_collected_date}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>
                    :
                    <></>
                }

              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6 mb-2 ">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Remarks
                </label>
                <textarea

                  value={remarks}
                  name="remarks"

                  onChange={(e) => handleData(e)}
                  className={`form-control form-g1`}
                />

              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-6 mt-4 col-md-6">
              <button type="submit" className="btn-primary form-btn me-5 mb-5">
                {tenantData?.status !== "Pending" ? "Payment" : "save"}
              </button>




              <button type="button" onClick={handleEditField} className="btn-primary form-btn  me-5 mb-5">
                Edit
              </button>


            </div>
          </div>
        </form>
      </DashboardLayouts>
    </>
  );
}
export default RentDetailsManagerPr;
